import { render, staticRenderFns } from "./ManageNotificationEmails.vue?vue&type=template&id=83a74cb0&scoped=true&"
import script from "./ManageNotificationEmails.vue?vue&type=script&lang=js&"
export * from "./ManageNotificationEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a74cb0",
  null
  
)

export default component.exports